import "@smartling/core-bundled/styles";

import React from "react";
import { createRoot } from "react-dom/client";
import { IntlProvider } from "react-intl";
import messages from "../dist/i18n/locales/en-US.json"; // eslint-disable-line

import { App } from "./modules/app";

const initApp = () => {
    const container = document.querySelector(".app-body")!;
    const root = createRoot(container);

    root.render(
        <IntlProvider
            locale="en-US"
            messages={messages}
        >
            <App />
        </IntlProvider>
    );
};

initApp();
